import { createSelector } from 'reselect';

export const getForm = (state, { applicationId }) => (state.form.base.forms[applicationId] ? state.form.base.forms[applicationId].form : null);

export const getAdditionalInfo = createSelector([getForm], (form) => ((form || {}).additionalInfo || []));
